module.exports = __webpack_public_path__ + "img/herb-basil-190x100.8d139e47.jpg";